const launchVideo = (url) => {
  let event = document.createEvent('Event')
  event.videoUrl = url
  event.initEvent('launchVideoModal', true, true)
  window.dispatchEvent(event)
}

export default launchVideo
